import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Translation } from '../interfaces/translation.interface';
import { environment } from '../environments/environment';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new AppTranslateLoader(http);
}

export class AppTranslateLoader implements TranslateLoader {
  readonly apiUrl = environment.translationApiUrl;

  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`${this.apiUrl}/exportJson/wemine_tech?lang=${lang}`).pipe(
      catchError((err) => {
        console.error('Failed to load translations from API:', err);
        return throwError(() => new Error('Could not load translations.'));
      })
    );
  }
}
